import React from "react";
import { AppProvider } from "../context/context";
import TicketsRaisedList from "./TicketsRaisedList";
import {
  LicenseTypes,
  MapPageFor,
  PriorityEnum,
} from "../../../../../utils/Enum.types";
import { TicketStatus } from "../../../../../utils/constants";
import { NavTypeProps } from "../MapsIndex";

interface Props extends NavTypeProps {
  ticketStatusType: TicketStatus;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  ticketPriority: PriorityEnum;
}

const TicketRaisedListIndex = ({
  NavType,
  pageFor,
  ticketStatusType,
  setModalFlag,
  ticketPriority,
}: Props) => {
  return (
    <AppProvider>
      <TicketsRaisedList
        NavType={NavType}
        pageFor={pageFor}
        ticketStatusType={ticketStatusType}
        setModalFlag={setModalFlag}
        ticketPriority={ticketPriority}
      />
    </AppProvider>
  );
};

export default TicketRaisedListIndex;
